import { render, staticRenderFns } from "./update-group-name.html?vue&type=template&id=b8f041be&scoped=true&external"
import script from "./update-group-name.js?vue&type=script&lang=js&external"
export * from "./update-group-name.js?vue&type=script&lang=js&external"
import style0 from "./update-group-name.scss?vue&type=style&index=0&id=b8f041be&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f041be",
  null
  
)

export default component.exports